const ByConfirmationCodeController = function ($rootScope, $state, customerModelService, SettingsConstants,
                                               apiService, ssWidgetService, vehicleService, $timeout, errorScreenService,
                                               ERR, $filter) {

    $rootScope.appLoadState = {...$rootScope.appLoadState, notHideAutomatically: true};

    // This flag is used to enable hiding user data on the appointment-summary page
    $rootScope.hideUserData = true;

    async function searchAppointment(vehicle, apptConfirmationCode) {
        let appts = await vehicle.getAppointments();
        appts = appts.appointments.filter(o => o.status === 'booked');

        let foundAppt;
        for await (const appt of appts) {
            try {

                appt.getAppointment.requestTransformation = ({url, methodData, data}) => {
                    url += "/confirmationcode/" + apptConfirmationCode;
                    methodData.config = Object.assign({}, methodData.config, {ignoreErrors: true});
                    return {url, methodData, data};
                }

                const appointment = await appt.getAppointment();
                if (appointment) {
                    foundAppt = appointment;
                    break;
                }
            } catch (e) {
            }
        }
        return foundAppt;
    }

    async function resolve() {
        const apptConfirmationCode = $state.params.code;
        if (apptConfirmationCode) {

            customerModelService.setSearchParameter(apptConfirmationCode);

            const customers = await customerModelService.searchCustomer(apptConfirmationCode);
            const customer = customers[0];
            customer.existingCustomer = true;
            customerModelService.setCustomer(customer, true);

            customerModelService.setCurrentVehicle(vehicleService.extend(await (customer.vehicles[0]).getVehicle()));
            const vehicle = customerModelService.getCurrentVehicle();
            const appointment = await searchAppointment(vehicle, apptConfirmationCode);

            customer.firstName = appointment.customer.firstName;
            customer.lastName = appointment.customer.lastName;

            const phones = appointment.customer.phones;
            if (phones && phones.length) {
                customer.phone = _.get(_.find(phones, {type: "default"}) || _.get(phones, 0), 'number');
            }

            const emails = appointment.customer.emails;
            if (emails && emails.length) {
                customer.email = _.get(_.find(emails, {type: "default"}) || _.get(emails, 0), 'email');
            }

            ssWidgetService.setSessionId('urn.dfx.confirmation-code.' + appointment.confirmationCode);

            function processServices(appServices, ossServices) {
                _.forEach(appServices, function (s) {
                    s.selected = true;
                });
                var services = _.concat(appServices, ossServices);
                var sortedServices = _.orderBy(services, {selected: true}, 'desc');
                return _.uniqBy(sortedServices, 'id');
            }

            const repairServices = processServices(appointment.services.repair,
                await appointment.resolveCustomerConcernsServices());
            const drServices = processServices(appointment.services.drs, []);
            const frServices = processServices(appointment.services.frs, []);
            const recalls = processServices(appointment.services.recalls, []);

            customerModelService.setCurrentAppointment(appointment);
            customerModelService.setCustomerConcernsServices(repairServices);
            customerModelService.setConcernsDescription(appointment.customerConcernsInfo);
            customerModelService.setDealerRecommendedServices(drServices, true);
            customerModelService.setFactoryRequiredServices(frServices, true);
            customerModelService.setCurrentTransportationOption(appointment.transportationOption);
            customerModelService.setCurrentScheduledTime({time: appointment.scheduledTime, available: true});
            customerModelService.setRecallsUpdates(recalls);

            vehicle.odometer = appointment.mileage.value;

            const [adviser, transportationOption, surveyServices] = await Promise.all([
                appointment.getAdviser(),
                (appointment.resolveTransportationOption || appointment.transportationOption.resolveTransportationOption)(),
                customerModelService.resolveSurveyServices(repairServices)
            ]);

            customerModelService.setCurrentAdviser(adviser);
            customerModelService.setCurrentTransportationOption(transportationOption);

            hideLoader();

            $timeout(function () {
                $state.go('summary');
            })
        }
    }

    $rootScope.$on("appIsRunning", () => {
        resolve()
            .then(() => {})
            .catch((e) => {
                customerModelService.setCustomer(undefined);
                customerModelService.setDataProperty('customerVerified', null);
                customerModelService.setVehicles([]);
                hideLoader();
                SettingsConstants.APP_DEFAULT_STATE = 'searchresults';
                errorScreenService.error(true, ERR.SEARCH_ERROR);
                $state.go('searchresults');
            });
    })

    function hideLoader() {
        $rootScope.appLoadState = {...$rootScope.appLoadState, notHideAutomatically: false};
        if ($rootScope.appLoadState.nextValue) {
            $rootScope.appLoadState.value = $rootScope.appLoadState.nextValue;
            delete $rootScope.appLoadState.nextValue;
        }
    }
};
ByConfirmationCodeController.$inject = ['$rootScope', '$state', 'customerModelService', 'SettingsConstants',
    'apiService', 'ssWidgetService', 'VehicleService', '$timeout', 'errorScreenService', 'errors', '$filter'];

module.exports = ByConfirmationCodeController;
